'use client';
import React from 'react';


const Custom404 = () => {
  const errorMessage = "This page has ceased to be! It's expired and gone to meet its maker! This is a late page! It's a stiff! Bereft of life, it rests in peace! If you hadn't nailed it to the perch it'd be pushing up the daisies! Its metabolic processes are now history! It's off the twig! It's kicked the bucket, it's shuffled off its mortal coil, run down the curtain and joined the bleedin' choir invisible!! THIS IS AN EX-PAGE!!";
  const words = errorMessage.split(' ');// Calculate the starting font size and decrement
  const startFontSize = 24; // Starting font size in pixels
  const decrement = 0.5; // Decrease font size by 0.5px for each word
  return (
    <>
      <div className="flex items-center justify-center min-h-screen">
        <div className="px-40 py-20 rounded-md shadow-xl">
          <div className="flex flex-col items-center">
            <h1 className="font-bold text-teal-600 text-9xl">404</h1>
            <h6 className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
              <span className="text-red-500">Oops!</span> Page not found
            </h6>
            <div className="text-center max-w-xs mx-auto">
            {words.map((word, index) => {
              const fontSize = Math.max(startFontSize - index * decrement, 10); // Ensure font size does not go below 10px
              return (
                <span key={word + index} style={{ fontSize: `${fontSize}px` }} className="inline-block mr-2">
                  {word}
                </span>
              );
            })}
            </div>
            <p className="mb-8 text-center md:text-lg">
              "And now for something completely different..."
            </p>
            <a href="/" className="px-6 py-2 text-sm font-semibold text-teal-800 bg-purple-100">Go Home</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Custom404;
